import React from 'react';
import Container from '../../atoms/Container/Container';
import Styles from './BlogDescricao.css';

function BlogDescricao({ text, children, id, ...props }) {
  return (
    <>
      <section {...props} id={id} className={`blog-description ${props.className}`}>
        <Container extraPadding>
          <h3>{text || children}</h3>
        </Container>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

BlogDescricao.defaultProps = {
  id: 'sec-blog-descricao',
};

export default BlogDescricao;
